import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: "root"[]
 * }>} ContainerStyles
 */
export const containerStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.Container} args.component - Video component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {ContainerStyles} - Component styles
   */
  baseStyle({component}) {
    return {
      root: {
        ...(
          component.fullWidth === 'No' ? {} :
            component.fullWidth === 'Yes' ? {maxWidth: '100%', paddingX: 0} :
              component.fullWidth === 'Yes, Desktop Only' ? ({
                maxWidth: {base: 'container.xxxl', lg: '100%'},
                paddingX: [4, 4, 6, 0],
              }) :
                component.fullWidth === 'Yes, Mobile Only' ? ({
                  maxWidth: {base: '100%', lg: 'container.xxxl'},
                  paddingX: [0, 0, 0, 6, 8, 8],
                }) :
                  {}
        ),
      },
    };
  },
});
